import { createContext, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { paginationVal } from "../utils/constants";
import useAxios from "../utils/useAxios";
import { useSSO } from "./AuthContext";

const MyProposalsContext = createContext();

export default MyProposalsContext;

export const MyProposalsProvider = ({ children }) => {
  const api = useAxios();
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState('');
  const [proposalList, setProposalList] = useState([]);

  const { apiRes, setApiRes } = useSSO();

  const pageData = useRef({ ...paginationVal });

  const tableHeading = [
    'SL NO', 'PROPOSAL TITLE', 'REFERENCE', 'DATE', 'COMPANY NAME',
    'CUSTOMER FULL NAME', 'RANDOMNESS', 'STATUS',
  ];

  const getMyProposals = async () => {
    try {
      setApiRes({ ...apiRes, loading: true });
      const response = await api.get('/api/proposal/list/get', {
        params: {
          search_query: searchQuery,
          page: +pageData.current.pageNumber,
        }
      });
      setApiRes({ ...apiRes, loading: false });
      setProposalList(response.data.items);
      pageData.current.pageCount = response.data.total_pages;
    } catch (err) {
      let errorMessage = 'Something went wrong.';
      if (!navigator.onLine || err.code === 'ERR_NETWORK' || !err.response) {
        errorMessage = 'No internet connection. Please try again later.';
      } else {
        errorMessage = JSON.stringify(err.response.data).replace(/[{}[\]"']/g, '')
      }
      setApiRes({
        ...apiRes,
        axiosError: true,
        errMsg: errorMessage,
        errHeading: 'My Proposals',
      });
    }
  };

  useEffect(() => {
    if (searchQuery) getMyProposals();
  }, [searchQuery]);

  const navigateToEdit = (id) => {
    navigate(`/proposal/${id}`);
  };

  const handlePaginationClick = (e, pageNumber) => {
    pageData.current.pageNumber = pageNumber;
    getMyProposals();
  };

  const contextData = {
    apiRes: apiRes,
    setApiRes: setApiRes,
    getMyProposals: getMyProposals,
    tableHeading: tableHeading,
    proposalList: proposalList,
    pageData: pageData,
    handlePaginationClick: handlePaginationClick,
    navigateToEdit: navigateToEdit,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
  };

  return (
    <MyProposalsContext.Provider value={contextData}>
      {children}
    </MyProposalsContext.Provider>
  )
};